import * as actionTypes from "../actionTypes";
import * as api from "../../api/index";
import { toast } from 'react-toastify';

export const GetNotes = () => async (dispatch) => {
  try {
    const { data } = await api.getNotes();
    dispatch({ type: actionTypes.GET_NOTES, payload: data });
  } catch (error) {
    toast.error("Failed to load notes.");
  }
};

export const CreateNote = (navigate) => async (dispatch) => {
  try {
    const { data, status } = await api.createNote({ title: "", body: {} });
    if (status === 201) {
      dispatch({ type: actionTypes.CREATE_NOTE, payload: data });
      navigate(`/app/${data.id}`);
    }
  } catch (error) {
    if (error.response?.status === 402) {
      dispatch({ type: actionTypes.NOTE_LIMIT_REACHED, payload: error.response.data?.max_notes });
    } else {
      toast.error("Failed to create note.");
    }
  }
};

export const UpdateNote = (id, noteData) => async (dispatch) => {
  try {
    const { data } = await api.updateNote(id, noteData);
    dispatch({ type: actionTypes.UPDATE_NOTE, payload: data });
  } catch (error) {
    // Silent failure on autosave — do not interrupt the user
    console.warn("Autosave failed", error);
  }
};

export const DeleteNote = (id, navigate) => async (dispatch) => {
  try {
    await api.deleteNote(id);
    dispatch({ type: actionTypes.DELETE_NOTE, payload: id });
    if (navigate) navigate("/app");
  } catch (error) {
    toast.error("Failed to delete note.");
  }
};
